import { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Divider, List, ListItem } from '@mui/material';
import { ServiceItem } from 'orderme-api-integration-client';
import { ServiceClient } from '../../helpers/client';
import { Linear } from '../progressBars/linear';
import { ProductCard } from '../productCard/productCard';
import { animated, useTransition } from '@react-spring/web';
import { getUserId } from '../../helpers/customerHelper';
import { SelectedGroupServicesProps } from '../../interfaces/interfaces';
import { appStyleMode, IsGtagEnabled } from '../../helpers/clientConfigs';
import { AppStyle } from '../../helpers/appStyle';
import { isDevEnvironment } from '../../env';
import { HtmlViewer } from '../../controls/html/htmlViewer';

export function ServicesList(props: SelectedGroupServicesProps) {
  const { serviceGroup, serviceCategory } = props;
  const servicesClient = useMemo(() => new ServiceClient(), []);
  const [serviceItems, setServiceItems] = useState<ServiceItem[]>();

  const loadGroupServices = useCallback(() => {
    servicesClient
      .getGroupServices(serviceGroup.id, getUserId())
      .then((response) => {
        setServiceItems(response);
      })
      .catch((err) => console.log(err));
  }, [serviceGroup, servicesClient]);

  useEffect(() => {
    setServiceItems(undefined);
    if (serviceGroup && serviceGroup.id) {
      loadGroupServices();
    }
  }, [serviceGroup, loadGroupServices]);

  useEffect(() => {
    if (!serviceGroup || !serviceCategory) {
      return;
    }

    try {
      if (appStyleMode !== AppStyle.Mobile && !isDevEnvironment() && IsGtagEnabled) {
        gtag('event', 'select_content', {
          content_type: serviceCategory.name,
          content_id: serviceGroup.name + ' | ' + serviceCategory.name,
        });
      }
    } catch (ex) {
      console.error(ex);
    }
  }, [serviceGroup, serviceCategory]);

  const transitions = useTransition(serviceItems, {
    from: { transform: 'translate3d(0,-250px,0)', opacity: 0 },
    enter: { transform: 'translate3d(0,0px,0)', opacity: 1 },
  });

  return (
    <>
      <Box className={appStyleMode === AppStyle.Mobile ? 'services-list' : null}>
        {serviceGroup.description && (
          <Box>
            <HtmlViewer content={serviceGroup.description} />
            <Divider />
          </Box>
        )}
        {serviceItems === undefined ? (
          <Linear />
        ) : (
          <List sx={{ overflow: 'auto' }}>
            {transitions((props, item) => (
              <animated.div style={props}>
                <ListItem sx={{ display: 'flex', justifyContent: 'center' }}>
                  <ProductCard
                    item={item}
                    backgroundColor="card.primary.background"
                    fontSize={15}
                    fontColor="card.primary.color"
                  />
                </ListItem>
              </animated.div>
            ))}
          </List>
        )}
      </Box>
    </>
  );
}
